import { extend } from 'vee-validate'
const validator = {
  params: ['target'],
  validate (value, { target }) {
    return value !== target
  }
}
extend('not_same_password', validator)
